export const timekeepingSettingVI = {
    "timeKeeping-setting": {
        "timeKeeping-setting": {
            "timeKeeping-setting": "Cài chấm công",
            "general-settings-header": "CÀI ĐẶT CHUNG",
            "general-settings": {
                "time-attendance-code": "Mã chấm công lấy theo",
                "time-attendance-code-detail": "Mã chấm công có thể lấy theo mã nhân sự hoặc mã độc lập, tốt nhất nên lấy theo mã nhân sự, trong trường hợp này bạn cần cài đặt thêm thông tin phía dưới",
                "time-attendance-code-from-handmade": "Nhập mã chấm công",
                "time-attendance-code-from-auto": "Lấy theo mã nhân sự",
                "general-settings-auto": {
                    "take-it": "Lấy theo n số cuối của mã nhân sự",
                    "take-it-detail": "Vì thực tế mã chấm công chỉ cho điền ký tự số nên đôi khi mã chấm công được lấy bởi những số cuối của mã nhân sự (vì có thể mã nhân sự chứa cả ký tự chữ)",
                    "take-it-form": "Nhập số cuối mã nhân sự"
                },
                "time-start-time-keeping": "Ngày bắt đầu tính công hàng tháng",
                "time-start-time-keeping-detail": "Là ngày bắt đầu chu kỳ tính công, lấy theo tháng dương lịch",
                "exempted-from-closing": "Khoảng thời gian rỗi được phép miễn chốt",
                "exempted-from-closing-detail": "Ví dụ: Trong công đoạn này bạn chọn 15 phút, giả sử nhân sự làm 2 khoảng làm việc cách nhau 10 phút thì nhân sự đó không cần chốt ra khoảng ca trước và vào khoảng ca sau, hệ thống sẽ tự hiểu là nhân sự làm nối tiếp",
                "show-on-timesheet": "Hiển thị trên bảng chấm công",
                "show-on-timesheet-detail": "Tùy theo mục đích bạn muốn thể hiển trên bảng chấm công, hãy lựa chọn cài đặt theo mục đích bạn muốn hiển thị trên bảng chấm công",
                "show-by-job": "Hiển thị theo công",
                "show-by": "Công theo ca + làm thêm",
                "show-by1": "Công theo ca",
                "show-by-hour": "Hiển thị theo giờ",
                "code-api-time-keeping": "Mã bảo mật của api chấm công",
                "code-api-time-keeping-detail": "Cần mã để nhận biết được chốt vân tay này từ máy chấm công nào",
                "time-keeping-url": "Đường dẫn kết nối máy chấm công với Dogoo Office",
                "time-keeping-url-title": "Tải tool đồng bộ dữ liệu từ máy chấm công",
            },
            "time-keeping-gps": {
                "setting-gps-header": "CHẤM CÔNG THEO ĐỊNH VỊ GPS",
                "setting-gps": "Cài đặt sử dụng GPS",
                "setting-gps-detail": "Hãy bật khi công ty bạn dùng chấm công bằng định vị GPS",
                "dot-location-setting-gps": "Địa điểm chấm công GPS",
                "dot-location-setting-gps-ref": "Đi tới cài đặt",
                "setting": "Cài đặt",
                "copy" : "Đã sao chép nội dung thành công!"
            },
            "api-time-keeping": {
                "api-time-keeping-header": "API CHẤM CÔNG",
                "api-time-keeping-setting": "Cài đặt API chấm công",
                "api-time-keeping-setting-detail": "Cho phép khách hàng dùng các từ khóa trong bảng ngày để lấy ra thông tin của nhân sự : thời gian chấm công, đi muộn, về sớm..."
            },
            "other-settings": {
                "other-settings-header": "CÀI ĐẶT KHÁC",
                "line-split": "Tách dòng chấm công của nhân sự",
                "line-split-detail": "Trong 1 tháng, nhân sự có thể ở phòng ban, vị trí hoặc mức lương khác nhau. Mỗi giá trị như vậy cần thể hiện trên 1 dòng. Vì vậy việc tách dòng là cần thiết để quản lý có cái nhìn trực quan.",
                "line-split-select": {
                    "not-line-split": "Không tách dòng",
                    "job-line-split": "Theo công chuẩn",
                    "position-line-split": "Theo vị trí, phòng ban",
                    "position-salary-line-split": "Theo lương vị trí",
                    "subsidies-salary-line-split": "Lương phụ cấp",
                    "the-labor-contract": "Theo hợp đồng lao động"
                },
                "rounding-factor": "Hệ số làm tròn",
                "rounding-factor-detail": "Ví dụ: Bạn cài 0.125 thì khi bạn làm lúc 07:01 thì hệ thống làm tròn lên 08:00. Thông thường, các công ty sẽ không làm tròn và sẽ lấy đúng giờ thực tế.",
                "advance-work-day": "Ứng trước ngày công",
                "advance-work-day-detail": "Sẽ có những công ty ngày 30 mới kết thúc tháng chấm công nhưng ngày 20 đã phát lương, nhân sự hoàn toàn có thể chấp nhận tạm ứng cho nhân viên công từ ngày 20 – 30 để tính lương",
                "advance-work-day-form": {
                    "advance-is-allowed": "Được phép ứng trước",
                    "no-advance-is-allowed": "Không phép ứng trước"
                },
                "single-word-latch": "Chốt đơn từ",
                "single-word-latch-detail": "Chốt đơn là 1 nghiệp vụ nhằm không cho phép nhân viên thực hiện việc tạo đơn từ trong tháng đó nữa, nhằm tránh những sai sót cho việc tính toán trong bảng chấm công. Có 2 cách chốt: Tự động theo ngày cố định hàng tháng hoặc bạn có thể chốt bằng tay trên bảng chấm công.",
                "single-word-form": "Thủ động",
                "single-word-form-auto": "Tự động",
                "single-word-latch-auto": "Ngày chốt tự động công sau kỳ công số ngày là",
                "single-word-latch-auto-detail": "Trường hợp bạn chọn chốt tự động thì hãy chọn ngày bạn muốn chốt"
            }
        },
        "compensation-setting": {
            "compensation-header": "Cài đặt nghỉ bù",
            "allow-compensation": "Cho phép nghỉ bù",
            "allow-compensation-detail": "Nghỉ bù tuy không quy định trong luật nhưng nhiều doanh nghiệp áp dụng hình thức này khi nhân viên làm thêm giờ,thay vì trả tiền thì được quy đổi sang nghỉ bù.",
            "conversionRate": "Tỉ lệ chuyển đổi thời gian làm thêm và thời gian nghỉ bù",
            "conversionRate-detail": "Ví dụ: Bạn cài tỷ lệ là 1.5 nghĩa là 1 giờ làm thêm sẽ quy đổi ra 1.5 giờ nghỉ bù",
            "timeExpire": "Thời gian hết hạn",
            "timeExpireDetail": "Thời gian được phép nghỉ bù tính từ lúc bắt đầu đơn làm thêm và đơn tăng ca. Sau thời gian này thì nhân sự không được hưởng thời gian nghỉ bù của đơn đó nữa.",
            "timeExpireForm": {
                "doesNotExpire": "Không Hết Hạn",
                "expiresInMonth": "Hết Hạn Trong Tháng",
                "1Month": "1 Tháng",
                "3Month": "3 Tháng",
                "6Month": "6 Tháng",
                "12Month": "12 Tháng"
            },
            "compensatory-leave": "Ứng trước nghỉ bù",
            "compensatory-leave-detail": "Tương tự nghỉ phép, nếu bật lựa chọn này, nghĩa là doanh nghiệp bạn cho phép nhân viên ứng trước quỹ nghỉ bù.",
            "compensatory-leave-maxtime": "Số giờ nghỉ bù tối đa được ứng",
            "compensatory-leave-maxtime-detail": "Ví dụ: Bạn được ứng 4 giờ thì khi tạo đơn xin nghỉ thời gian không được vượt quá 4 giờ",
            "compensatory-leave-maxtime-form": "Giờ"
        },
    }
}
